import  { useState } from 'react'
import {NavLink, useNavigate} from 'react-router-dom'
import user from '../assets/user.png'
import styled from 'styled-components';
import toast,{Toaster} from 'react-hot-toast';
import {useFormik} from 'formik';
import { profileValidate } from '../Helpers/validate';
import { useAuthStore } from '../store/store';
import { registerUser } from '../Helpers/helper';  //needs to be changed
import { updateUser } from '../Helpers/helper';
import useFetch from '../hooks/fetch.hook';
import { Button } from '../styles/Button';
import UserMenu from './UserMenu';
import PageHeader from "../components/PageCloseButton";
import { Country, State, City }  from 'country-state-city';
import AddressForm from './AddressForm';
import { toTitleCase, normalize, normalizeNoSpaces } from "../Helpers/stringTitlecase.js";


const Profile= () => {
   const [file,setFile]=useState() ;  
   const { username } = useAuthStore(state => state.auth);
   const logout=useAuthStore(state=>state.logout)
   const [selectedCountry, setSelectedCountry] = useState(null);

const [formAddress, setFormAddress] = useState({
  country: '',
  state: '',
  city: '',
  address: '',
  isdCode: '',
});
const [countries] = useState(Country.getAllCountries());

   const navigate=useNavigate();
   const [{ isLoading, apiData, serverError }] = useFetch(username ? `user/${username}` : null);
  //  const [{ isLoading, apiData, serverError }] = useFetch(`user/${username}`);
   const [previewUrl, setPreviewUrl] = useState(user);
   const [selectedFile, setSelectedFile] = useState(null);
   
  
  const onUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      setSelectedFile(file);
      setPreviewUrl(URL.createObjectURL(file));
    }
  };

  const  formik=useFormik({
    initialValues:{
      name:apiData?.name ||'',
      company:apiData?.company||'',
      country:apiData?.country||'',
      address:apiData?.address||'',
      businesstype:apiData?.businesstype||'',
      email:apiData?.email ||'',
      mobile:apiData?.mobile ||'',
      isdCode:apiData?.isdCode ||'',
    },
    enableReinitialize:true,
    validate:profileValidate,
    validateOnBlur:false,
    validateOnChange:false,
   

    onSubmit: async (values) => {
        try {
            // Step 1: Upload image if selected
            let uploadedImageUrl = '';
            if (selectedFile) {
              const formData = new FormData();
              formData.append('profile', selectedFile);
    
              const uploadRes = await fetch(`${process.env.REACT_APP_SERVER_DOMAIN}/api/upload`, {
                method: 'POST',
                body: formData
              });
    
              if (!uploadRes.ok) {
                throw new Error('Image upload failed');
              }
    
              const uploadData = await uploadRes.json();
              uploadedImageUrl = uploadData.imageUrl;
            }
    
            // Step 2: Submit registration with imageUrl
            values = Object.assign(values, {
              profile: uploadedImageUrl || apiData?.profile || ''
            });
    
            } catch (error) {
            toast.error(error.message || 'Something went wrong');
          }
          let updatePromise=updateUser(values);
            toast.promise(updatePromise,{
            loading:'Updating...',
            success:<b>Profile Updated Successfully....</b>,
            error:<b>Could not Update</b>
          })
        }
      })

  // =========Country Change==================================================
  const handleCountryChange = (country)=>{
  setSelectedCountry(country);
  setFormAddress((prev) => ({
    ...prev,
    country: country.name,
    isdCode: country.phonecode,
  }));
  formik.setFieldValue("country", country.name);
  formik.setFieldValue("isdCode", country.phonecode)
};

  return (
    <Wrapper>
      <Toaster position='top-center' reverseOrder={false}></Toaster>
        <div className="grid grid-two-column">
          <UserMenu/>                                         
            <div className='user-container'>
              <PageHeader title="Profile" />  
              <div className='header-container'>              
              <span className='userspan'>You can update the details</span>
              <label htmlFor='profile'>
                  <img className='user-img' src={apiData?.profile || file || user} alt='user-img'/>
                  </label>
                  <input type='file' 
                  id='profile' 
                  name='profile' 
                  onChange={onUpload} 
                  />
              </div> 
                <form onSubmit={formik.handleSubmit} autoComplete="off">  
                <div className="form-container">
                    <label htmlFor="name">Name</label>
                   <input
                      type="text"
                      placeholder="Name"
                      value={formik.values.name}
                      onChange={(e) =>
                      formik.setFieldValue("name", toTitleCase(e.target.value))
                      }
                    />

                    <label htmlFor="company">Company</label>
                    
                    <input                    
                    type="text"
                      placeholder="Company"
                      value={formik.values.company}
                      onChange={(e) =>
                      formik.setFieldValue("company", toTitleCase(e.target.value))
                      }
                    
                    />
                    <label htmlFor="country">Country</label>
                    <select
                      id="country"
                      value={formik.values.country}
                      onChange={(e) => {
                        const selected = countries.find(c => c.name === e.target.value);
                        handleCountryChange(selected);
                        formik.setFieldValue("country", e.target.value); 
                      }}
                    >
                      <option value="">Select Country</option>
                      {countries.map((c) => (
                        <option key={c.isoCode} value={c.name}>
                          {c.name}
                        </option>
                      ))}
                    </select>
                                        
            
                    <label htmlFor="businesstype">Business Type</label>
                    <select
                      id="businesstype"
                      className="businesstype"{...formik.getFieldProps('businesstype')}>
                      <option value="" label="Select business type" />
                      <option value="Importer" label="Importer" />
                      <option value="Exporter" label="Exporter" />
                      <option value="Merchant" label="Merchant" />
                      <option value="Wholesaler" label="Wholesaler" />
                      <option value="Retailer" label="Retailer" />
                      <option value="Buyer" label="Buyer" />
                      <option value="Other" label="Other" />
                    </select>
                    
                      <label htmlFor="Mobile No">Mobile No.</label>
                      <div style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
                      <input {...formik.getFieldProps('isdCode')}
                        type="text"
                        value={formik.values.isdCode ? `+${formik.values.isdCode}` : ""}
                        readOnly
                        style={{ width: "80px", }}
                        />
                        <input {...formik.getFieldProps('mobile')}
                        type='text' className='mobile'
                        placeholder='Mobile No.'
                        />
                      </div>
              
                    <label htmlFor="email">e-mail</label>
                    <input {...formik.getFieldProps('email')}
                    type='email' className='email'
                    placeholder='e-mail' 
                    />
                </div>
                <div className="form-container">
                  <Button type='submit'>Update</Button>
                  <hr />
                   <p className="user-para">
                    Comeback later? 
                    <span className="linkspan">
                      <Button 
                        onClick={() => {
                          logout(); 
                          navigate("/"); 
                        }}
                      >
                        Logout
                      </Button>
                    </span>
                  </p>
                </div>                
                </form>                 
            </div>            
          </div>
        
    </Wrapper>
  )
}
const Wrapper=styled.section`

.grid-two-column {
    display: grid;
    grid-template-columns: 2fr 8fr;
    gap: 2rem;
     }

.user-container {
    width: 40%;
    margin: 3rem auto;
    border-radius: 0.8rem;
    background: ${({ theme }) => theme.colors.bg};
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);
    display: flex;
    flex-direction: column;  
    padding: 1rem; 
  }

.header-container {
   display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
   }
    
 .userspan {
    font-size: 15px;
    text-align: center;
    color: blue;
  }

.user-img{
  padding:0.4rem;
  width:8rem;
  height:8rem;
  border:1px solid white;
  box-shadow:1px 1px 1px 1px #dfdfdf;
  border-radius:50%;
  object-fit: cover;
}
  input[type='file'] {
  display: none;
  }

.form-container{
  display: flex;
  flex-direction: column;
  padding: 1.5rem;
  width: 100%; 
}

  hr{
    margin: 1.5rem 0;
    border: none;
    border-top: 1px solid #ccc;
    }

.user-para {
  display: flex;
    justify-content: center;
    align-items: center;
    gap: 2rem;
    font-size: 1.5rem;
    margin-top: 1rem;
}

 linkspan {
    font-weight: bold;
    color: black;
  }

@media (max-width: ${({ theme }) => theme.media.mobile}) {
  .grid {
    grid-template-columns: 1fr;
    }

  .user-container {
    width: 95%;
    margin: 2rem auto;
    }

  .form-container {
    width: 100%
    }

  .userspan{
   font-size: 1.5rem; 
   }
}
`;

export default Profile